import React from 'react';

import { ShimmerCategoryItem, ShimmerTable } from 'react-shimmer-effects';

const CategoryItem = (): JSX.Element => {
  return (
    <ShimmerCategoryItem
      hasImage
      imageType="circular"
      imageWidth={50}
      imageHeight={50}
      text
      contentCenter
    />
  );
};

const ListShimmer = (): JSX.Element => {
  return <CategoryItem />;
};

const TableShimmer = (): JSX.Element => {
  return <ShimmerTable row={3} col={3} />;
};

const StatusShimmer = (): JSX.Element => {
  return <ShimmerTable row={2} col={2} />;
};

export const ShimmerComponents = {
  list: ListShimmer,
  status: StatusShimmer,
  table: TableShimmer,
  custom: ListShimmer,
};
